const hexByCssColor = new Map<string, string>();
const warnedTokens = new Set<string>();

/**
 * The engine's colour parser takes `#hex` / `rgb()` only (engine/psd-render/core/src/color.rs), so a token
 * resolving to `oklch()` would silently fail to paint. Rasterise one pixel and read it back — the browser
 * converts any CSS colour space for us. Cached on the raw token value, so this runs once per distinct colour
 * instead of once per compose; a theme switch changes the value and therefore the key.
 */
export function cssColorToHex(css: string): string {
  const cached = hexByCssColor.get(css);
  if (cached !== undefined) return cached;

  const ctx = document.createElement('canvas').getContext('2d');
  if (!ctx) return css;
  ctx.fillStyle = css;
  ctx.fillRect(0, 0, 1, 1);
  const [r, g, b] = ctx.getImageData(0, 0, 1, 1).data;
  const hex = `#${[r, g, b].map(channel => channel.toString(16).padStart(2, '0')).join('')}`;
  hexByCssColor.set(css, hex);
  return hex;
}

/** Resolves a ds-theme token to a colour the engine can paint. */
export function tokenColor(token: string): string {
  const css = getComputedStyle(document.documentElement).getPropertyValue(token).trim();
  if (css === '' && !warnedTokens.has(token)) {
    warnedTokens.add(token);
    console.warn(`[psd-render] token ${token} resolved to nothing — painting black`);
  }

  return cssColorToHex(css);
}
